import type { ResolverInput, ResolverResult } from './types';

// Stub. Two contractor tables exist: `contractors` (migration 007) and
// `contractor_profiles` (migration 024 — "contractor_consolidation").
// Phase 4 will determine which is authoritative and write the real resolver.
// Until then, always returns incomplete.
export async function resolveAddContractorsItem(
  _input: ResolverInput,
): Promise<ResolverResult> {
  return { complete: false, reason: 'item form not yet built' };
}
